import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-financial',
  templateUrl: './icon-financial.component.html',
  styles: []
})
export class IconFinancialComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
